<se-fe-page>
  <se-fe-header
    seFePageHeader
    seFeDataTitle="Grade Select"
    seFeDataSubtitle="A grade / grad year selector"
    size="750">
  </se-fe-header>
  <div seFePageContent>
    <se-fe-card>
      <se-fe-card-header seFeDataTitle="When to use"></se-fe-card-header>
      <se-fe-card-content>
        <p>Use this component for graduation year select inputs</p>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card class="form-example">
      <se-fe-card-header seFeDataTitle="Example Code"></se-fe-card-header>
      <se-fe-card-content>
        <se-po-graduation-select-example></se-po-graduation-select-example>
      </se-fe-card-content>
    </se-fe-card>
  </div>
</se-fe-page>
